import React, { useState, useEffect } from "react"
import { Input } from "@fourkites/elemental-input"
import BottomBar from "../BottomBar/bottombar"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import { useDispatch, useSelector, connect, ConnectedProps } from "react-redux"
import { useHistory } from "react-router"
import { RootState } from "store/store"
import "./PurposeRequest.css"
import { http } from "utils/http"
import { apiEndPoints } from "constants/apiEndpoints"
import {
  appointment,
  asset,
  matchingVisitDetail,
  appointmentDetails,
  carrier,
  equipment
} from "../../store/actions/types"
import { setAppointment } from "../../store/actions"
import { withRouter, RouteComponentProps } from "react-router-dom"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"
import i18next from "i18next"

const PurposeRequest = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const visitReducer = useSelector((state: RootState) => state.visitReducer)
  const assetReducer = useSelector((state: RootState) => state.assetReducer)
  const [Reference, setReference] = useState("")
  const [purposeins, setpurposeins] = useState("")
  const [isdisabled, setisdisabled] = useState(true)

  const dispatch = useDispatch()

  useEffect(() => {
    var purposeText = assetReducer.asset?.trailerStatus
    switch (purposeText) {
      case "Loaded Trailer":
        setpurposeins(
          "(Load Number, Stop Reference Number, Trailer Number Shipment ID, PO or BOL)"
        )
        break
      case "Empty Trailer":
        setpurposeins(
          "(Truck Number, Trailer Number, Outbound Shipment Number, etc.,)"
        )
        break
      case "Trailer":
        setpurposeins("(Truck Number, Outbound Shipment Number, etc.,)")
        purposeText = t("trailer")
        break
      case "Visitor":
        setpurposeins("(Truck Number, etc.,)")
        purposeText = t("visitor")
        break
    }
  })

  const setValue = (event: any) => {
    if (event.target.value.trimLeft().length > 0) {
      setisdisabled(false)
    } else {
      setisdisabled(true)
    }
    setReference(event.target.value.trimLeft())
  }

  const setPurpose = () => {
    http
      .post(
        `${apiEndPoints.fetchAppointment}`,
        {
          identifierType: "any",
          identifierValue: Reference,
          visitId: visitReducer.visit.id,
          mode: "kiosk"
        },
        {}
      )
      .then(response => {
        const { data } = response.data

        let appointmentDT: appointment = {
          type: data.appointment?.type,
          details: data?.appointmentDetails,
          matchingVisitDetails: data.matchingVisitDetails,
          smsMatchingVisitDetails: data?.matchingVisitDetails,
          isNewSession: false
        }

        dispatch({
          type: "SET_APPOINTMENT",
          payload: appointmentDT
        })

        let asset = {
          ...assetReducer.asset,
          referenceNumber: Reference,
          tractor: data.appointmentDetails[0].assetDetails.tractor
            ? data.appointmentDetails[0].assetDetails.tractor?.number
            : "",
          trailer: data.appointmentDetails[0].assetDetails.trailer
            ? data.appointmentDetails[0].assetDetails.trailer?.number
            : "",
          usdot: data.appointmentDetails[0].companyDetails
            ? data.appointmentDetails[0].companyDetails?.usdot
            : "",
          companyName: data.appointmentDetails[0]
            ? data.appointmentDetails[0].companyDetails?.name
            : ""
        }

        dispatch({
          type: "SET_ASSET_INFO",
          payload: asset
        })

        history.push("/kiosk-carrier-info")
      })
      .catch(err => toast.error(err.response.data.error))
  }

  const trans = (key: string) => {
    return i18next.t(key) || ""
  }

  return (
    <div className="container">
      <div className="purpose-request-header">
        {t("please_enter_your")} <br />
        {t("reference_number")}
      </div>
      <div className={`driver-input driver-input-USDOT-font`}>
        <Input
          placeholder={trans("enter_reference_here")}
          label={trans("enter_reference_here")}
          hideLabel={true}
          maxLength={20}
          value={Reference}
          onChange={(event: any) => setValue(event)}
        />
      </div>
      <div className="purpose-ins">{purposeins}</div>
      <BottomBar
        disabled={isdisabled}
        onClick={() => setPurpose()}
        text={t("continue")}
        endIcon={<KeyboardArrowRightIcon />}
      />
    </div>
  )
}
export default PurposeRequest
